/**
 * Traditional Chinese (TWD + HKD + USD) mock entity data for the marketing-
 * site mockups. Row shapes mirror the app's API rows (see
 * shared-site-web/screens/*.js), so the real column definitions and
 * table components can render them.
 */

/** @type {Array<import('../../mock-data.js').MockAccount>} */
export const MOCK_ACCOUNTS_ZH_TW = [
	{ id: 'acc-checking', name: '常綠銀行', accountType: 'Bank Account', currency: 'TWD', currencySymbol: 'NT$', currencyDecimalPlaces: 0, balance: 92400, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-savings', name: '定期存款', accountType: 'Bank Account', currency: 'TWD', currencySymbol: 'NT$', currencyDecimalPlaces: 0, balance: 480000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-broker', name: '成長型基金', accountType: 'Investment Account', currency: 'HKD', currencySymbol: 'HK$', currencyDecimalPlaces: 2, balance: 592308, principal: 626462, updatedAt: '2026-08-08' },
	{ id: 'acc-pension', name: '退休金', accountType: 'Pension', currency: 'HKD', currencySymbol: 'HK$', currencyDecimalPlaces: 2, balance: 229744, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-property', name: '我的家', accountType: 'Real Estate', currency: 'TWD', currencySymbol: 'NT$', currencyDecimalPlaces: 0, balance: 11200000, principal: 8960000, updatedAt: '2026-08-08' },
	{ id: 'acc-flight', name: '飛行哩程', accountType: 'Points/Miles', currency: 'MILES', currencySymbol: '\u2708', currencyDecimalPlaces: 0, balance: 84620, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-credit', name: '港島返利卡', accountType: 'Credit Card', currency: 'HKD', currencySymbol: 'HK$', currencyDecimalPlaces: 2, balance: 21620, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-joke', name: '美股組合', accountType: 'Investment Account', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 19938, principal: 10956, updatedAt: '2026-08-08' },
];

/**
 * Custom currencies (TWD base) for the currencies use case. MILES and HP
 * carry a manual rate so the currency table shows the manual marker "(M)".
 * HKD has a manual rate so the cross-currency credit card converts cleanly.
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_CURRENCIES_ZH_TW = [
	{ code: 'TWD', isCustom: 0, name: '新台幣', symbol: 'NT$', decimalPlaces: 0, isBase: 1, rate: 1, manualRate: null },
	{ code: 'HKD', isCustom: 0, name: '港幣', symbol: 'HK$', decimalPlaces: 2, isBase: 0, rate: 3.9, manualRate: 3.9 },
	{ code: 'USD', isCustom: 0, name: '美元', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 32.1, manualRate: null },
	{ code: 'MILES', isCustom: 1, name: '飛行哩程', symbol: '\u2708', decimalPlaces: 0, isBase: 0, rate: 0.3, manualRate: 0.3 },
	{ code: 'HP', isCustom: 1, name: '飯店點數', symbol: 'P', decimalPlaces: 0, isBase: 0, rate: 0.2, manualRate: 0.2 },
	{ code: 'SM', isCustom: 1, name: '狀態哩程', symbol: 'SM', decimalPlaces: 0, isBase: 0, rate: 0, manualRate: 0 },
];

/**
 * Everyday currencies (TWD base) with auto-fetched rates for the
 * multi-currency use case.
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_RATES_ZH_TW = [
	{ code: 'TWD', isCustom: 0, name: '新台幣', symbol: 'NT$', decimalPlaces: 0, isBase: 1, rate: 1, manualRate: null },
	{ code: 'HKD', isCustom: 0, name: '港幣', symbol: 'HK$', decimalPlaces: 2, isBase: 0, rate: 3.9, manualRate: null },
	{ code: 'USD', isCustom: 0, name: '美元', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 32.1, manualRate: null },
	{ code: 'JPY', isCustom: 0, name: '日圓', symbol: '\u00A5', decimalPlaces: 0, isBase: 0, rate: 0.21, manualRate: null },
];
